import { render, staticRenderFns } from "./SplitButton.vue?vue&type=template&id=7be4998c&"
import script from "./SplitButton.vue?vue&type=script&lang=js&"
export * from "./SplitButton.vue?vue&type=script&lang=js&"
import style0 from "./SplitButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports